const shortLocaleCharacters: { [key: string]: { year: string; month: string; day: string } } = {
  ko: {
    year: '-',
    month: '-',
    day: '',
  },
  ja: {
    year: '年',
    month: '月',
    day: '日',
  },
};

const defaultLocaleCharacters: { [key: string]: { year: string; month: string; day: string } } = {
  ko: {
    year: '년',
    month: '월',
    day: '일',
  },
  zh: {
    year: '年',
    month: '月',
    day: '日',
  },
  ja: {
    year: '年',
    month: '月',
    day: '日',
  },
};

export const customLongDateFormat = (language: string, market: string) => {
  const code = language.split('-')[0];
  const emptyChar = { year: null, month: null, day: null };
  const defaultChar = defaultLocaleCharacters[code] || emptyChar;
  const shortDateChar = shortLocaleCharacters[code] || emptyChar;
  // TODO: confirm with PDM is MD and YM formats are correct per country
  const MD = `${defaultChar.month ? `M${defaultChar.month}` : 'MMM'}${
    defaultChar.day ? `D${defaultChar.day}` : ' DD'
  }`;
  const YM = `YYYY${defaultChar.year || '-'}M${defaultChar.month || ''}`;
  const L = `YYYY${shortDateChar.year || '/'}M${shortDateChar.month || '/'}D${shortDateChar.day ||
    ''}`;
  const LL = `YYYY${defaultChar.year || '-'}M${defaultChar.month || '-'}D${defaultChar.day || ''}`;
  const LLL = `YYYY${defaultChar.year || ' '}M${defaultChar.month || ' '}D${defaultChar.day || ''}`;
  const Y = `YYYY${defaultChar.year || ''}`;
  const shouldPmAmBeforeTime = language === 'ko-KR' || code === 'zh';
  switch (market) {
    case 'KOR':
      return {
        MD: MD,
        YM: YM,
        Y: Y,
        L: 'YYYY-MM-DD',
        LL: LL,
        LLL: LLL,
        LT: shouldPmAmBeforeTime ? 'a h:mm' : 'h:mm a',
        LTS: shouldPmAmBeforeTime ? 'a h:mm:ss' : 'h:mm:ss a',
        INPUT: 'YYYY-MM-DD',
      };
    case 'JPN':
      return {
        MD: MD,
        YM: YM,
        Y: Y,
        L: L,
        LL: LL,
        LLL: LLL,
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        INPUT: 'YYYY/MM/DD',
      };
    case 'HKG':
    case 'MAC':
      return {
        MD: MD,
        YM: YM,
        Y: Y,
        L: 'D/M/YYYY',
        LL: LL,
        LLL: LLL,
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        INPUT: 'DD/MM/YYYY',
      };
    case 'TWN':
      return {
        MD: MD,
        YM: YM,
        Y: Y,
        L: 'YYYY/M/D',
        LL: LL,
        LLL: LLL,
        LT: shouldPmAmBeforeTime ? 'a hh:mm' : 'hh:mm a',
        LTS: shouldPmAmBeforeTime ? 'a hh:mm:ss' : 'hh:mm:ss a',
        INPUT: 'YYYY/MM/DD',
      };
    case 'CHN':
      return {
        MD: MD,
        YM: YM,
        Y: Y,
        L: 'YYYY/M/D',
        LL: LL,
        LLL: LLL,
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        INPUT: 'YYYY/MM/DD',
      };
    case 'THA':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'D/M/YYYY',
        LL: 'DD MMM YYYY',
        LLL: 'D MMMM YYYY',
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        INPUT: 'DD/MM/YYYY',
      };
    case 'IDN':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'DD/MM/YYYY',
        LL: 'DD MMMM YYYY',
        LLL: 'DD MMMM YYYY',
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        INPUT: 'DD/MM/YYYY',
      };
    case 'USA':
      return {
        MD: 'MMM DD',
        YM: 'YYYY/M',
        Y: 'YYYY',
        L: 'M/D/YYYY',
        LL: 'DD-MMM-YY',
        LLL: 'MMMM DD, YYYY',
        LT: shouldPmAmBeforeTime ? 'a h:mm' : 'h:mm a',
        LTS: shouldPmAmBeforeTime ? 'a h:mm:ss' : 'h:mm:ss a',
        INPUT: 'MM/DD/YYYY',
      };
    case 'SGP':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'D/M/YYYY',
        LL: 'DD MMM YYY',
        LLL: 'D MMMM YYYY',
        LT: shouldPmAmBeforeTime ? 'a h:mm' : 'h:mm a',
        LTS: shouldPmAmBeforeTime ? 'a h:mm:ss' : 'h:mm:ss a',
        INPUT: 'DD/MM/YYYY',
      };
    case 'AUS':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'D/MM/YYYY',
        LL: 'DD-MMM-YY',
        LLL: 'D MMMM YYYY',
        LT: shouldPmAmBeforeTime ? 'a h:mm' : 'h:mm a',
        LTS: shouldPmAmBeforeTime ? 'a h:mm:ss' : 'h:mm:ss a',
        INPUT: 'DD/MM/YYYY',
      };
    case 'CAN':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'DD/MM/YYYY',
        LL: 'DD-MMM-YY',
        LLL: 'MMMM-DD-YY',
        LT: shouldPmAmBeforeTime ? 'a h:mm' : 'h:mm a',
        LTS: shouldPmAmBeforeTime ? 'a h:mm:ss' : 'h:mm:ss a',
        INPUT: 'DD/MM/YYYY',
      };
    case 'FRA':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'DD/MM/YYYY',
        LL: 'D MMM YY',
        LLL: 'D MMMM YY',
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
      };
    case 'GBR':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        L: 'DD/MM/YYYY',
        LL: 'DD MMMM YYYY',
        LLL: 'DD MMMM YYYY',
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        INPUT: 'DD/MM/YYYY',
      };
    case 'PHL':
      // TODO: check if MD format is correct
      return {
        MD: 'MMM DD',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'M/D/YYYY',
        LL: 'DD-MMM-YY',
        LLL: 'MMMM DD, YYYY',
        LT: shouldPmAmBeforeTime ? 'a h:mm' : 'h:mm a',
        LTS: shouldPmAmBeforeTime ? 'a h:mm:ss' : 'h:mm:ss a',
        INPUT: 'MM/DD/YYYY',
      };
    case 'DEU':
      return {
        MD: 'DD MMM',
        YM: 'M.YYYY',
        Y: 'YYYY',
        L: 'DD.MM.YYYY',
        LL: 'DD.MMM.YY',
        LLL: 'D.MMMM YYYY',
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        INPUT: 'DD.MM.YYYY',
      };
    case 'IND':
      return {
        MD: 'DD MMM',
        YM: 'M-YYYY',
        Y: 'YYYY',
        L: 'DD-MM-YYYY',
        LL: 'DD MMM YYYY',
        LLL: 'DD MMMM YYYY',
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        INPUT: 'DD-MM-YYYY',
      };
    case 'ITA':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'DD/MM/YYYY',
        LL: 'D-MMM-YY',
        LLL: 'D MMMM YYYY',
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        INPUT: 'DD/MM/YYYY',
      };
    case 'VNM':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'DD/MM/YYYY',
        LL: 'DD MMMM YYYY',
        LLL: 'DD MMMM YYYY',
        LT: shouldPmAmBeforeTime ? 'a h:mm' : 'h:mm a',
        LTS: shouldPmAmBeforeTime ? 'a h:mm:ss' : 'h:mm:ss a',
        INPUT: 'DD/MM/YYYY',
      };
    case 'ESP':
      return {
        MD: 'DD MMM',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'DD/MM/YYYY',
        LL: 'DD.MMM.YYYY',
        LLL: 'DD MMMM YYYY',
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        INPUT: 'DD/MM/YYYY',
      };
    case 'MYS':
      return {
        MD: 'MMM DD',
        YM: 'M/YYYY',
        Y: 'YYYY',
        L: 'DD/MM/YYYY',
        LL: 'DD MMMM YYYY',
        LLL: 'DD MMMM YYYY',
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        INPUT: 'DD/MM/YYYY',
      };
  }
  return {
    MD: 'MMM DD',
    YM: 'M/YYYY',
    Y: 'YYYY',
    L: 'L',
    LL: 'LL',
    LLL: 'LLL',
    LT: 'LT',
    LTS: 'LTS',
    INPUT: 'YYYY/MM/DD',
  };
};
